import CancelablePromise from "cancelable-promise";
import { ReleaseLock } from "../../lib/utils/CancelableSemaphoreAcquire.js";
import { MediaResource } from "../player/MediaResource.js";
import { MediaGarbageCollector } from "./MediaGarbageCollector.js";

/**
 * A no-op implementation of the `MediaGarbageCollector` interface.
 * 
 * `NullGC` does not perform any garbage collection or resource management.
 * All methods are implemented as stubs that immediately resolve or return their inputs.
 * 
 * @typeParam PlayerType - The type of the media player.
 * @typeParam RES - The type of the media resource, extending `MediaResource`.
 */
export class NullGC<PlayerType, RES extends MediaResource<PlayerType, any, any>> implements MediaGarbageCollector<PlayerType, RES> {


    constructor() {

    }

    start(): void {

    }
    addResource(resource: RES): Promise<RES> {
        return Promise.resolve(resource);    
    }
    addResourceAsync(asyncResource: CancelablePromise<RES>): CancelablePromise<RES> {
        return asyncResource;
    }

    lock(): Promise<ReleaseLock> {
        return Promise.resolve(() => {});
    }
  
}
